<template>
  <div class="foodChoose">
    <div class="foodChoose-main">
      <div
        v-for="item in ingredList"
        :key="item.productId"
        :data="JSON.stringify(setBuboiTs(item))"
        class="foodChoose-item"
      >
        <div :key="item.imgUrl" class="hometagWrap">
          <openWxTag
            :id="'goodsTitle' + item.productId"
            :path="`/subPackages/shopMainProcess/product/index?productId=${item.productId}&skuId=${item.skuId}`"
            btnStyle="width:100%;height:204px"
            @sensorsFn="setPoint(item)"
          ></openWxTag>
        </div>
        <img :src="item.imgUrl" alt="" />
        <div class="foodChoose-item-title">{{ item.title }}</div>
        <div class="foodChoose-item-money">
          <span v-if="item.price" class="fuhao">￥</span>
          <span v-if="item.price" class="money-price">{{ item.price }}</span>
          <span
            v-if="!item.flag && item.price && item.integral"
            class="money-fh"
            >+</span
          >
          <span v-if="item.flag && item.price && item.integral" class="money-fh"
            >/</span
          >
          <span v-if="item.integral" class="foodChoose-item-integral">{{
            item.integral
          }}</span>
          <span v-if="item.integral" class="integral">积分</span>
          <img
            alt=""
            class="img-pos"
            src="@/assets/images/babyFeeding/shopCar.png"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { goToMini, TestUserAgent } from '@/assets/js/common.js'
import openWxTag from '@/components/common/openWeappTag/index.vue'
import {
  BuiedPointClick_Fn,
  Exposurer_babyShop_Fn,
} from '@assets/js/BuriedPointEvent'

export default {
  name: 'foodChoose',
  data() {
    return {
      ingredList: this.ingredientList, //数据列表
      isSystem: '',    }
  },
  props: {
    tagId: [String, Number],
    ingredientList: [],
  },
  mounted() {
    this.isSystem = TestUserAgent().isios
  },
  components: {
    openWxTag,
  },
  watch: {
    ingredientList: {
      handler(newValue) {
        this.ingredList = newValue
        this.$nextTick(() => {
          Exposurer_babyShop_Fn.observe(
            'xmhh5_bbsp_goods_view',
            '.foodChoose-item',
            false
          )
        })
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    goToMini,
    setPoint(value) {
      BuiedPointClick_Fn('xmhh5_bbsp_goods_vclick', {
        xmhh5_bbsp_pagename: this.$route.meta.title,
        xmhh5_bbsp_goodsname: value.title,
      })
    },
    setBuboiTs(data) {
      return {
        xmhh5_bbsp_pagename: this.$route.meta.title,
        xmhh5_bbsp_goodsname: data.title,
      }
    },
  },
}
</script>
<style lang="less" scoped>
@import '../../../../assets/font/font.less';

.foodChoose {
  .foodChoose-main {
    // display: flex;
    //justify-content: space-between;
    white-space: nowrap;
    overflow-x: scroll;

    .foodChoose-item {
      display: inline-block;
      width: 132px;
      height: 204px;
      overflow: hidden;
      border-radius: 4px;
      margin-right: 6px;
      background-color: #fff;
      position: relative;

      img {
        width: 132px;
        height: 132px;
      }

      .foodChoose-item-title {
        height: 33px;
        max-height: 33px;
        font-size: 12px;
        font-weight: 500;
        color: #333333;
        padding: 0 4px;
        margin: 2px 0;
        white-space: initial;
        overflow: hidden; //溢出内容隐藏
        text-overflow: ellipsis; //文本溢出部分用省略号表示
        display: -webkit-box; //特别显示模式
        -webkit-line-clamp: 2; //行数
        line-clamp: 2;
        -webkit-box-orient: vertical; //盒子中内容竖直排列
      }

      .foodChoose-item-money {
        display: flex;
        // align-items: center;
        align-items: flex-end;
        height: 24px;
        padding: 0 4px;
        font-size: 11px;
        // font-weight: bold;
        color: #ff0000;
        margin-top: 3px;
        position: relative;
        font-family: FeiHeShuZiTi;

        span {
          // line-height: 17px;
        }

        .fuhao {
          line-height: 17px;
        }

        .money-fh,
        .money-fh,
        .integral {
          line-height: 19px;
        }

        .money-price {
          font-size: 16px;
        }

        .foodChoose-item-integral {
          font-size: 16px;
          // line-height: 19px;
          font-weight: bold;
          color: #ff0000;
          font-family: FeiHeShuZiTi;
        }

        .img-pos {
          position: absolute;
          right: 4px;
          bottom: 4px;
        }

        .integral {
          font-size: 11px;
        }

        img {
          width: 18px;
          height: 15px;
          margin-left: 12px;
          vertical-align: middle;
        }
      }
    }
  }

  .foodChoose-main::-webkit-scrollbar {
    width: 0;
    display: none;
  }

  .hometagWrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 204px;
    z-index: 999;

    a {
      display: block;
      width: 100%;
      height: 204px;
    }
  }
}
</style>
